$(document).ready(function() {

	//셀렉트 선택시... 페이지 이동.
	$(".static-legal-select").change(function() {
		var value = $(this).val();
		// switch(value){
		// 	case 'op1': value = '/html/customer/static-legal.html'; break;
		// }
		location.href = value;
	});


});
